import { CLICK_ACTIONS } from './Constant';
import { ColumnHeaderType } from './Types';
import { blankValueGetter } from './Util';

export const VIEW_Leads_HEADER: ColumnHeaderType[] = [
  {
    field: 'leadId',
    name: 'Lead Id',
    valueGetter: blankValueGetter,
    clickable: true,
    action: CLICK_ACTIONS.VIEW_LEAD,
  },
  {
    field: 'leadTypeName',
    name: 'Lead Type',
    valueGetter: blankValueGetter,
  },
  {
    field: 'assignedToName',
    name: 'Assigned To',
    valueGetter: blankValueGetter,
  },
  {
    field: 'leadStatusName',
    name: 'Status',
    sortable: true,
    valueGetter: blankValueGetter,
  },
];
